import { createRoute, lazyRouteComponent, notFound } from "@tanstack/react-router";
import { rootRoute } from '../../../App';
import { getPublishedReviewByIdQuery, getPublishedSnapshotQuery } from '../../../api/publishedReviewsApi';
import { FullPageLoader } from '../../../components/FullPageLoader';

export const publishedReviewRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/published/$reviewId",
    // ?table={tableId} — the selected published table. Missing or unknown ids
    // fall back to the snapshot's first table (resolved in the page).
    validateSearch: (search: Record<string, unknown>): { table?: string } => ({
        table: typeof search.table === 'string' ? search.table : undefined,
    }),
    loader: async ({ context, params }) => {
        const review = await context.queryClient.ensureQueryData(getPublishedReviewByIdQuery(params.reviewId));
        if (!review) throw notFound();
        await context.queryClient.ensureQueryData(getPublishedSnapshotQuery(params.reviewId));
    },
    component: lazyRouteComponent(() => import('./PublishedReview.page')),
    pendingComponent: () => <FullPageLoader />,
});
